module.exports = __webpack_public_path__ + "static/media/24.5d3dedcf.jpg";